import { gql } from '@apollo/client';

export const RESET_USER_PASSWORD = gql`
  mutation ResetUserPassword($uuid: String!) {
    resetUserPassword(uuid: $uuid) {
      id
      uuid
    }
  }
`;
